import React from "react";
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { selectQueryParams, setQueryParams, updateQueryParams } from "../../ui/customerListingReducer";

const DissociateModal = (props) => {
  const {showDissociateModal, setShowDissociateModal, pincodeAttr} = props;
  const [dissociatePincodeApi] = getApi('dissociatePincode');
  const queryParams = useSelector(selectQueryParams);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    setShowDissociateModal(false);
  }

  const onDissociatePincodeClick = async () => {
    try{
      const response = await dissociatePincodeApi({id: `${pincodeAttr.id}`}).unwrap();
      setShowDissociateModal(false);
      toast.success(response.message || 'Pincode Dissociated From Cluster !');
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowDissociateModal(true);
      toast.error(error.message || 'Something went wrong !');
    }
  }

  return <Modal
    show={showDissociateModal}
    onHide={handleModalClose}
    backdrop="static"
    keyboard={false}
    centered
  >
    <Modal.Header
      style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
      className="text-white"
      closeButton
    >
      <Modal.Title>Dissociate PIN Code From Cluster</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='text-center m-2 text-warning'><FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/></div>
      <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
      <p className='h6 text-center my-3 opacity-75 fw-normal'>You want to remove Associated Pincode <span className="fw-bold">{pincodeAttr.pincode} - {pincodeAttr.area}</span> from cluster <span className="fw-bold">{pincodeAttr.cluster?.name}</span>?</p>
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn btn-sm add-button" style={{ width: "80px", fontSize: '16px' }} onClick={handleModalClose}>
        Cancel
      </button>
      <button type='submit' className='btn btn-sm remove-button' style={{ width: "80px", fontSize: '16px' }} onClick={(e) => {e.preventDefault(); onDissociatePincodeClick()}}>
        Remove
      </button>
    </Modal.Footer>
  </Modal>
}

export default DissociateModal;
